// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Zo-z","slideIn":"_o-z"};